import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WelcomeMessage } from 'src/Model/WebCustomer';
import { ApiService } from '../service/api.service';
import { PosthogService } from '../analytics/services/posthog.service';
import { ThemeService } from '../service/theme.service';

@Component({
  selector: 'app-welcome-message',
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss'],
})
export class WelcomeMessageComponent implements OnInit, OnDestroy {
  message: WelcomeMessage;
  sub: Subscription;
  /* brands without a Theme keep their DynamicStyle button colour (see ThemeService.legacyAccentVars) */
  accentVars: Record<string, string> | null = null;

  constructor(
    private apiService: ApiService,
    private posthog: PosthogService,
    private theme: ThemeService
  ) {}

  ngOnInit(): void {
    this.getWebCustomer();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  getWebCustomer() {
    this.sub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) return;
      this.message = res.TemplateData.WelcomeMessage;
      this.accentVars = this.theme.legacyAccentVars(res);
    });
  }

  close() {
    this.posthog.captureEvent('welcome_message_closed', {
      messageTitle: this.message?.Title,
    });
    this.message.Enabled = false;
  }
}
